import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout/page-header';
import { UsageTab } from './usage-tab';

/**
 * Where the till discounts went.
 *
 * A finance report, gated on `viewDiscountReport` — the three roles
 * `GetDiscountsOnOrdersReportAsync` actually accepts. It stays in this feature
 * folder rather than moving to a reports one because its only filter is the
 * list of discounts the sibling page maintains: they read the same
 * `pos/discounts`, and splitting the folder would be the first step towards
 * two ideas of what a discount is.
 */
export function DiscountUsagePage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('posDiscounts.usageTitle')}
        description={t('posDiscounts.usageSubtitle')}
      />
      <UsageTab />
    </div>
  );
}
